




































































































































import type { PropType } from "vue"
import type { stadium_base } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import Amap from "@/components/amap.vue"
import AreaPicker from '@/components/areapicker.vue'

export default Vue.extend({
  name      : "StadiumBase",
  components: { AreaPicker, Amap },
  props     : {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_base> },
    correct : { type: Object, default() { return {} } },
    show    : { type: Object,
      default() {
        return {
          all          : true,
          name         : true,
          area         : true,
          addr         : true,
          contact      : true,
          sex          : true,
          contact_phone: true,
          phone        : true,
          longitude    : true,
          latitude     : true,
        }
      }
    },
  },
  data() {
    return {
      area   : [] as string[],
      city   : [] as string[],
      data   : {} as any,
      change : {
        sex: 1,
      } as any,
      options: [
        // { label: '未知', value: '0' },
        { label: '男', value: '1' },
        { label: '女', value: '2' },
      ],
      rules: {
        name         : { required: true, message: "场馆名称不能为空", trigger: "blur" },
        province_id  : { required: true, message: "场馆地区不能为空", trigger: "blur" },
        addr         : { required: true, message: "详细地址不能为空", trigger: "blur" },
        longitude    : { required: true, message: "经纬度不能为空", trigger: "blur" },
        phone        : { required: true, message: "场馆已经营年限不能为空", trigger: "blur" },
        contact      : { required: true, message: "场馆租赁剩余年限不能为空", trigger: "blur" },
        sex          : { required: true, message: "场馆租赁续签情况不能为空", trigger: "blur" },
        contact_phone: { required: true, message: "场馆总面积不能为空", trigger: "blur" },
      }
    }
  },
  computed: {
    if_correct() {
      return (key: string): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
          if (this.change.id && this.change.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const data = this.$deep_copy(this.form)
        this.area = [String(data.province_id.padEnd(6, "0")), String(data.city_id.padEnd(6, "0")), String(data.county_id)]
        this.data = data
      })
    },
    show_correct(key: string): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
        if (this.change.id && this.change.id > 0) correct = true
        else correct = false
      }
      return correct
    },
    choose_area(value: string[], options: any) {
      this.data.province_id = value[0] as string
      this.data.city_id     = value[1] as string
      this.data.county_id   = value[2] as string
      this.city = []
      for (const option of options) {
        this.city.push(option.label)
      }
      let area = ""
      for (const option of options) area += `${option.label}`
      this.data.area_name = area
    },
    amap_callback(lng: any, lat: any) {
      this.data.longitude = lng
      this.data.latitude  = lat
      /* this.form.setFieldsValue({
        lnglat: `${lng},${lat}`,
      }); */
    },
    submit() {
      const params = this.$deep_copy(this.data)
      params.estimate_id = this.id
      this.$emit("modify", params)
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          if (!this.correct.id) this.submit()
          this.change = this.$deep_copy(this.correct)
        })
      },
      deep: true
    }
  }
})
